// Auswahl der Flugart (VLoS / EVLoS / BVLoS) als Segment-Buttons. Erneutes Antippen hebt die Wahl auf (= nicht angegeben).
const FLUGARTEN = [
  { value: 'VLOS', label: 'VLoS', hinweis: 'in Sichtweite des Piloten' },
  { value: 'EVLOS', label: 'EVLoS', hinweis: 'erweiterte Sichtweite (Luftraumbeobachter)' },
  { value: 'BVLOS', label: 'BVLoS', hinweis: 'außerhalb der Sichtweite' },
]

interface FlugartWahlProps {
  value: string
  onChange: (wert: string) => void
  disabled?: boolean
}

export function FlugartWahl({ value, onChange, disabled = false }: FlugartWahlProps) {
  const aktiv = FLUGARTEN.find(f => f.value === value)
  return (
    <div className="mt-1.5">
      <div className="flex gap-2" role="group" aria-label="Flugart">
        {FLUGARTEN.map(f => (
          <button
            key={f.value}
            type="button"
            disabled={disabled}
            aria-pressed={value === f.value}
            title={f.hinweis}
            onClick={() => onChange(value === f.value ? '' : f.value)}
            className={`min-h-[48px] flex-1 rounded-xl border px-4 py-2 text-sm font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${
              value === f.value
                ? 'border-primary-500 bg-primary-500 text-white'
                : 'border-dark-border bg-dark-bg-tertiary text-dark-text-muted hover:border-primary-500/60'
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>
      <p className="mt-1 text-xs text-dark-text-muted">
        {aktiv ? aktiv.hinweis : 'Nicht angegeben'}
      </p>
    </div>
  )
}
